import React from 'react';
import {A11y, Navigation, Pagination, Scrollbar} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import {history} from "../../../history";
import {Card, CardBody, Col, Row} from "reactstrap";
import {Link} from "react-router-dom";

const SwiperCourse = ({data}) => {

    const course_box = data && data.map((item, index) => {
        return (
            <SwiperSlide key={index}>
                <Card className="courses" onClick={() => history.push("/course/" + item.slug)}>
                    <CardBody className='d-flex p-0 course-section'>
                        <Row className="w-100">
                            <Col md={7} sm={7} xs={7} className='overflow-hidden course-image'>
                                <div className='course-img'>
                                    <img src={item.image} alt={item.name} className="w-100 h-100 cursor-pointer"/>
                                </div>
                            </Col>
                            <Col md={5} sm={5} xs={5}
                                 className='d-flex align-items-stretch justify-content-start h-100 m-auto'>
                                <div
                                    className=' card-desc d-flex flex-column justify-content-around align-items-center'>
                                    <div className='card-desc-top'>
                                        <div className="course-title  cursor-pointer">
                                            <h5>{item.name}</h5>
                                            <h5>
                                                مدرس :
                                                <p>
                                                    {
                                                        item.teachers.map((teacher) => {
                                                            return (
                                                                <p>{teacher.name} {teacher.lastname}</p>
                                                            )
                                                        })
                                                    }
                                                </p>
                                            </h5>

                                            <h5>
                                                {
                                                    (item.duration > 0) ?
                                                        <>
                                                            طول دوره :
                                                            <p>{item.duration} روز </p>
                                                        </>
                                                        : ""
                                                }
                                            </h5>

                                            <h5>
                                                {
                                                    (item.badge === null) ?
                                                        "مدرک ندارد" :
                                                        <>
                                                            مدرک :
                                                            <p>{item.badge}</p>
                                                        </>
                                                }
                                            </h5>
                                        </div>
                                    </div>
                                    <div className='course-links'>
                                        <div className=''>
                                            <button onClick={() => history.push("/course/" + item.slug)}>
                                                ثبت نام دوره
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </SwiperSlide>

        )


    })

    const call_swiper = (
        <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={50}
            slidesPerView={4}
            navigation
            className="info-cards"
            breakpoints={{
                // when window width is >= 320px
                200: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                // when window width is >= 480px
                490: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                // when window width is >= 640px
                760: {
                    slidesPerView: 1.6,
                    spaceBetween: 10
                },
                1020: {
                    slidesPerView: 1.8,
                    spaceBetween: 0
                },
                1440: {
                    slidesPerView: 2.2,
                    spaceBetween: 40
                }
            }}>
            {course_box}
        </Swiper>
    )

    return (
        <div className="swiper-course-home">
            {call_swiper}
        </div>
    );
};

export default SwiperCourse;
